import '@app/libs/dynamicImportListener';
import ReactDOM from 'react-dom/client';

import '@ui/styles/index.css';

import { App } from './App';

ReactDOM.createRoot(document.getElementById('root')!).render(
  // <React.StrictMode>
  <App />,
  // </React.StrictMode>,
);
